import { Image } from 'react-bootstrap';
import clsx from 'clsx';
import './BayLoader.scss';

interface BayLoaderProps {
  small?: boolean;
  imageUrl?: string;
  className?: string;
}

const BAY_LOADER_GIF = 'https://bay.cdn.backatyou.com/ui/BAY-Loader.gif';

const BayLoader = ({
	small = false,
	imageUrl,
	className,
}: BayLoaderProps) => {
	return (
		<div className={clsx('bay-loader', { 'bay-loader--small': small, 'bay-loader-wrapper': !small }, className)}>
			<Image className="bay-loader-img" src={imageUrl || BAY_LOADER_GIF} />
		</div>
	);
};

export default BayLoader;
